// extracted by mini-css-extract-plugin
export default {"root":"textInput_root__qIPvS","wrap_root":"textInput_wrap_root__WdxOO"};